import ListManager from './ListManager.component';

export default ListManager;
